import { render, staticRenderFns } from "./FAQitem.vue?vue&type=template&id=9eadf094"
import script from "./FAQitem.vue?vue&type=script&lang=js"
export * from "./FAQitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports